import IObservation from "../interfaces/IObservation";
import IPerson from "../interfaces/IPerson";
import { observationToPersonIds } from "./data.helpers";
import _uniq from "lodash/uniq";
import { IObservationPackage } from "../interfaces/ObservationPackage/ObservationPackage";
import { IHavainnotFormSchema } from "../interfaces/IFormSchema";


export interface TIdentifiersDTO {
    henkilot: string;
    kohteet: string;
    lomakkeet: string;
};


export interface TIdentifiers {
    henkilot: Array<IPerson["id"]>;
    kohteet: Array<string>;
    lomakkeet: Array<string>;
};


export const extractFormDataIdentifiers = (formData: IObservation["formData"], schema: IHavainnotFormSchema): TIdentifiers => {
    const identifiers: TIdentifiers = {
        henkilot: [],
        kohteet: [],
        lomakkeet: []
    };

    let personIds = observationToPersonIds(formData, schema)
    identifiers.henkilot = personIds;


    const markings = formData.merkinnat;
    if (markings?.length) {
        let markingPersons: typeof personIds = [];
        markings.forEach((marking) => {
            if (marking.creator) {
                markingPersons = [...markingPersons, marking.creator]
            };
            if (marking.formData.vastaanottaja) {
                markingPersons = [...markingPersons, marking.formData.vastaanottaja]
            };
        });
        identifiers.henkilot = _uniq([...identifiers.henkilot, ...markingPersons]);
    };
    


    if (formData.kohde || formData.sijainti) {
        identifiers.kohteet = [(formData.kohde || formData.sijainti) as any];
    };

    return identifiers
};

export const extractFormDataIdentifiersDTO = (formData: IObservation["formData"], formSchema: IHavainnotFormSchema): TIdentifiersDTO | string => {
    const identifiers = extractFormDataIdentifiers(formData, formSchema);

    if ((identifiers.henkilot.length + identifiers.kohteet.length + identifiers.lomakkeet.length) === 0) {
        return "n/a"
    };

    return {
        henkilot: identifiers.henkilot.join(","),
        kohteet: identifiers.kohteet.join(","),
        lomakkeet: identifiers.lomakkeet.join(","),
    }
}


export const pacakgeToIdentifiers = (json: IObservationPackage): TIdentifiersDTO | string => {
    if (!json.observation.formSchema) {
        throw Error("Form configuration is missing")
    };

    const identifiers = extractFormDataIdentifiers(json.observation.formData, json.observation.formSchema);

    if (json.observation.editor) {
        identifiers.henkilot = [...identifiers.henkilot, json.observation.editor];
    };

    if (json.observation.creator) {
        identifiers.henkilot = [...identifiers.henkilot, json.observation.creator];
    };

    if (json.observation.target) {
        identifiers.kohteet = [...identifiers.kohteet, json.observation.target as any];
    };

    if (json.observation.formType) {
        identifiers.lomakkeet = [...identifiers.lomakkeet, json.observation.formType as any];
    };


    if ((identifiers.henkilot.length + identifiers.kohteet.length + identifiers.lomakkeet.length) === 0) {
        return "n/a"
    };

    return {
        henkilot: identifiers.henkilot.join(","),
        kohteet: identifiers.kohteet.join(","),
        lomakkeet: identifiers.lomakkeet.join(","),
    }
}